<template>
	<div class="formkit-matrix">
		<div class="formkit-matrix-scroll">
			<table class="formkit-matrix-table">
				<thead>
					<tr>
						<th class="formkit-matrix-cell formkit-matrix-cell--header formkit-matrix-cell--row-header"></th>
						<th
							v-for="col in columns"
							:key="col"
							class="formkit-matrix-cell formkit-matrix-cell--header"
						>
							{{ col }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in matrixRows" :key="row">
						<td class="formkit-matrix-cell formkit-matrix-cell--row-header">
							{{ row }}
						</td>
						<td
							v-for="col in columns"
							:key="col"
							class="formkit-matrix-cell"
						>
							<label class="formkit-matrix-radio">
								<input
									type="radio"
									:name="`${context.node.name}-${row}`"
									:value="col"
									:checked="isSelected(row, col)"
									@change="handleSelect(row, col)"
								/>
								<span class="formkit-matrix-radio-indicator"></span>
							</label>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
	context: {
		type: Object,
		required: true,
	},
});

const columns = computed(() => props.context.columns ?? []);
const matrixRows = computed(() => props.context.matrixRows ?? []);

const modelValue = computed(() => props.context._value || {});

const isSelected = (row, col) => {
	return modelValue.value[row] === col;
};

const handleSelect = (row, col) => {
	const newValue = { ...modelValue.value, [row]: col };
	props.context.node.input(newValue);
};
</script>

<style scoped>
.formkit-matrix {
	width: 100%;
}

.formkit-matrix-scroll {
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
}

.formkit-matrix-table {
	width: 100%;
	border-collapse: collapse;
	min-width: 400px;
}

.formkit-matrix-cell {
	padding: 0.75rem 0.5rem;
	text-align: center;
	border-bottom: 1px solid #e2e8f0;
}

.formkit-matrix-cell--header {
	background: #f8fafc;
	font-weight: 600;
	color: #1e293b;
	font-size: 0.875rem;
}

.formkit-matrix-cell--row-header {
	text-align: left;
	color: #334155;
	font-weight: 500;
	min-width: 120px;
}

.formkit-matrix-radio {
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.formkit-matrix-radio input {
	position: absolute;
	opacity: 0;
	width: 0;
	height: 0;
}

.formkit-matrix-radio-indicator {
	width: 24px;
	height: 24px;
	border: 2px solid #d9d5c8;
	border-radius: 50%;
	background: white;
	transition: all 0.2s;
	position: relative;
}

.formkit-matrix-radio input:checked + .formkit-matrix-radio-indicator {
	border-color: #4b1b6b;
	background: #4b1b6b;
}

.formkit-matrix-radio input:checked + .formkit-matrix-radio-indicator::after {
	content: "";
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 8px;
	height: 8px;
	background: white;
	border-radius: 50%;
}

.formkit-matrix-radio:hover .formkit-matrix-radio-indicator {
	border-color: #6b2e93;
}

@media (min-width: 768px) {
	.formkit-matrix-cell {
		padding: 1rem 0.75rem;
	}
}
</style>
